
import Group from 'vux/src/components/group/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'

export default {
name: 'HelloWorld',
data() {
return {
pages: [{
key: "singer",
name: "singer",
id: "aa"
},
{
key: "album",
name: "album",
id: "aa"
},
{
key: "rank",
name: "rank",
id: "aa"
},
{
key: "cd",
name: "cd",
id: "aa"
},
]
}
},
components: {
Group,
CellBox
}
}




// WEBPACK FOOTER //
// ./src/components/HelloWorld.vue